import React from "react";

function StatCard({ label, value, highlight }) {
  const base = "rounded-lg border p-4 flex flex-col items-start gap-1 shadow-sm transition-colors";
  const style = highlight === "red"
    ? "bg-red-50 border-red-200"
    : highlight === "green"
    ? "bg-emerald-50 border-emerald-200"
    : "bg-card border-border";

  const valueColor = highlight === "red"
    ? "text-red-600"
    : highlight === "green"
    ? "text-emerald-600"
    : "text-foreground";

  return (
    <div className={`${base} ${style}`}>
      <span className={`text-2xl font-bold ${valueColor}`}>{value}</span>
      <span className="text-xs text-muted-foreground font-medium">{label}</span>
    </div>
  );
}

export default function StatCards({ races, advertisers, stalenessThreshold, isOverdue }) {
  const totalRaces = races.length;
  const activeRaces = races.filter((r) => r.status === "Active").length;
  const totalAdvertisers = advertisers.length;
  const smgPlusAdvertisers = advertisers.filter((a) => a.smg_plus).length;
  const digitalOverdue = races.filter((r) => isOverdue(r.last_digital_sweep)).length;
  const linearOverdue = races.filter((r) => isOverdue(r.last_linear_sweep)).length;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
      <StatCard label="Total Races" value={totalRaces} />
      <StatCard label="Active Races" value={activeRaces} />
      <StatCard label="Total Advertisers" value={totalAdvertisers} />
      <StatCard label="SMG+ Advertisers" value={smgPlusAdvertisers} />
      <StatCard
        label="Digital Sweep Overdue"
        value={digitalOverdue}
        highlight={digitalOverdue > 0 ? "red" : "green"}
      />
      <StatCard
        label="Linear Sweep Overdue"
        value={linearOverdue}
        highlight={linearOverdue > 0 ? "red" : "green"}
      />
    </div>
  );
}